import { Component } from 'react';
import PropTypes from 'prop-types';

class LoaderHOC extends Component {
  render() {
    const {
      serviceId,
      placeHolderType,
      component,
      getServicesLoading
    } = this.props;
    return getServicesLoading(serviceId) ? placeHolderType() : component();
  }
}

LoaderHOC.propTypes = {
  component: PropTypes.func.isRequired,
  getServicesLoading: PropTypes.func.isRequired,
  placeHolderType: PropTypes.func.isRequired,
  serviceId: PropTypes.string.isRequired
};

export default LoaderHOC;



// WEBPACK FOOTER //
// ./src/components/atoms/LoaderHOC/LoaderHOC.js